var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-ontick-carbon-500 fixed inset-0 flex items-center justify-center"},[_c('i',{staticClass:"animate-pulse",domProps:{"innerHTML":_vm._s(_vm.$icons.logo_public)}}),_c('span',{staticClass:"sr-only"},[_vm._v("Carregando")])])
}
var staticRenderFns = []

export { render, staticRenderFns }